import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import Link from 'next/link';

const BountyBanner = () => {
  return (
    <div className="absolute top-8 left-1/2 -translate-x-1/2 z-10 pt-4 md:pt-6 lg:pt-10">
      <Link href="/creators" legacyBehavior>
        <a className="inline-flex items-center justify-center px-3 py-1.5 sm:px-5 sm:py-2.5 bg-black/30 hover:bg-black/40 backdrop-blur-md text-slate-100 hover:text-white rounded-full transition-all duration-200 group shadow-lg border border-white/10 text-xs sm:text-sm">
          <span className="mr-1.5 sm:mr-2 md:mr-2">🎉</span>
          <span className="whitespace-nowrap">Bounties Live!</span>
          <span className="mx-1 sm:mx-1.5 md:mx-1.5 text-slate-400">·</span>
          <span className="hidden sm:inline md:inline whitespace-nowrap">Get paid for clips</span>
          <span className="inline sm:hidden md:hidden whitespace-nowrap">Paid Clips</span>
          <span className="mx-1 sm:mx-1.5 md:mx-1.5 text-slate-400">·</span>
          <span className="group-hover:underline whitespace-nowrap">Explore Now</span>
          <ArrowUpRight className="ml-1 h-4 w-4 sm:h-5 sm:w-5 transition-transform duration-200 group-hover:translate-x-0.5" />
        </a>
      </Link>
    </div>
  );
};

export default BountyBanner; 